import { Fetch } from 'barnyard/utils/';
import * as constants from '../constants';


export const categoriesFetch = () => (dispatch, getState) => Fetch({
  url: '/api/products/categories/?history=1',
  success: (json) => {
    dispatch({
      type: constants.CATEGORIES_FETCH_SUCCESS,
      entities: _.indexBy(json, 'id')
    });
  }
});
